import { Typography } from '@mui/material';
import moment from 'moment';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Const from '../config/constant';
import { getS3SignedUrl } from './s3Service';
import { withStyles } from '@mui/styles';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as FileIcon } from "../static/file-icon.svg";
import { ReactComponent as TextIcon } from "../static/text-icon.svg";
import { ReactComponent as FormIcon } from "../static/form-icon.svg";
import { ReactComponent as LinkIcon } from "../static/link-icon.svg";
import { ReactComponent as UpArrowIcon } from "../static/up-arrow.svg";
import { ReactComponent as DownArrowIcon } from "../static/down-arrow.svg";
import { ReactComponent as EqualToIcon } from "../static/equal-to.svg";
const constant = Const;

export const filterFileds = (arr, selectedArray) => {
    let filteredArray = []
    arr.forEach((item) => {
        if (selectedArray.includes(item.user_name)) {
            filteredArray.push(item)
        }
    })
    return filteredArray
}
export const filterFileds2 = (arr, selectedArray) => {
    let filteredArray = []
    arr.forEach((item) => {
        let i = selectedArray.find((j) => j.email === item.email)
        if (i) {
            let obj = {}
            obj.first_name = item.first_name
            obj.last_name = item.last_name
            obj.user_name = item.user_name
            obj.email = item.email
            obj.id = item.id
            obj.review_status = 0 //1,2,3
            filteredArray.push(obj)
        }
    })
    return filteredArray
}
export const checkHaveSubmissions = ((collection, SelectedFilter) => {
    if (SelectedFilter.length === 0) {
        SelectedFilter = [constant.SUBMITTED, constant.REQUESTED, constant.ACCEPTED, constant.REJECTED, "Copied"]
    }
    let res = { haveSubmissions: false }
    collection?.requests?.structure?.sections.forEach((sec) => {
        if (sec.requests) {
            let a = sec.requests.find((req) => SelectedFilter.includes(req.status))
            if (a) {
                res.haveSubmissions = true;
            }
            if (SelectedFilter.includes("Copied")) {
                let b = sec.requests.find((req) => req.copied_to_dataroom || req.copied_to_drive)
                if (b) {
                    res.haveSubmissions = true;
                }
            }
        }
    })
    collection?.requests?.structure?.sections?.forEach((sec) => {
        if (sec.sub_section) {
            sec.sub_section.forEach((sub_sec) => {
                let a = sub_sec.requests.find((req) => SelectedFilter.includes(req.status))
                if (a) {
                    res.haveSubmissions = true;
                }
                if (SelectedFilter.includes("Copied")) {
                    let b = sub_sec.requests.find((req) => req.copied_to_dataroom || req.copied_to_drive)
                    if (b) {
                        res.haveSubmissions = true;
                    }
                }
            })
        }
    })
    return res
})

export const checkReviewSubmissions = ((collections) => {
    let haveSubmissions = [];
    collections.map((collection) => (
        collection.requests?.structure?.sections.forEach((sec) => {
            if (sec.requests) {
                let a = sec.requests.find((req) => req.status === constant.SUBMITTED || req.status === constant.ACCEPTED || req.status === constant.REJECTED || req.status === constant.REQUESTED)
                if (a) {
                    haveSubmissions.push(true);
                }
            }
            if (sec.sub_section) {
                sec.sub_section.forEach((sub_sec) => {
                    let a = sub_sec.requests.find((req) => req.status === constant.SUBMITTED || req.status === constant.ACCEPTED || req.status === constant.REJECTED || req.status === constant.REQUESTED)
                    if (a) {
                        haveSubmissions.push(true);
                    }
                })
            }
        })
    ))
    return haveSubmissions;
})

export const AssignedRequestCheckHaveSubmissions = ((collection) => {
    let res = { haveSubmissions: false }
    collection.requests.structure.sections.forEach((sec) => {
        if (sec.requests) {
            let a = sec.requests.find((req) => req.status === constant.SUBMITTED || req.status === constant.ACCEPTED || req.status === constant.REJECTED || req.status === constant.REQUESTED)
            if (a) {
                res.haveSubmissions = true;
            }
        }
    })
    collection.requests.structure.sections.forEach((sec) => {
        if (sec.sub_section) {
            sec.sub_section.forEach((sub_sec) => {
                let a = sub_sec.requests.find((req) => req.status === constant.SUBMITTED || req.status === constant.ACCEPTED || req.status === constant.REJECTED || req.status === constant.REQUESTED)
                if (a) {
                    res.haveSubmissions = true;
                }
            })
        }
    })
    return res
})

export const resetAttachments = ((attachments) => {
    if (attachments[0].type === 'form') {
        attachments[0].data?.sections?.map((sec) => {
            sec.mark_complete = 0
            sec.definition.map((def) => {
                def.value = ''
                return def
            })
            return sec
        })
    }
    return attachments
})
export const resetSectionsToDefault = ((sections, agentObj, clients) => {
    let res = []
    sections.forEach((sec) => {
        sec.requests.map((request) => {
            request.attachments = resetAttachments(request.attachments)
            request.client_attachments = []
            request.review_chats = []
            request.review_comments = []
            request.created_date = new Date()
            request.agents = agentObj
            request.status = ''
            request.clients = clients//since reqlib have no clients
            request.is_marked_as_ready = 0
            request.copied_to_dataroom = 0
            request.copied_to_drive = 0
            if ((request.attachments[0].type === constant.LINK || request.attachments[0].type === constant.FILE)) {
                request.dr_default_filename = request.dr_default_filename ?? ''
                request.dr_file_location = request.dr_file_location ?? null
                request.dr_file_type = 'issuer'
                request.dr_watermark = false
                request.dr_read_only = false
            }
            return request
        })
        sec.sub_section.map((sub_sec) => {
            sub_sec.requests.map((request) => {
                request.attachments = resetAttachments(request.attachments)
                request.client_attachments = []
                request.review_chats = []
                request.review_comments = []
                request.created_date = new Date()
                request.status = ''
                request.clients = clients//since reqlib have no clients
                request.agents = agentObj
                request.is_marked_as_ready = 0
                request.copied_to_dataroom = 0
                request.copied_to_drive = 0
                if ((request.attachments[0].type === constant.LINK || request.attachments[0].type === constant.FILE)) {
                    request.dr_default_filename = request.dr_default_filename ?? ''
                    request.dr_file_location = request.dr_file_location ?? null
                    request.dr_file_type = 'issuer'
                    request.dr_watermark = false
                    request.dr_read_only = false
                }
                return request
            })
        })
        res.push(sec)
    })
    return res
})
export const FilterRequests = ((collection, request, requestFilter,) => {
    if (!isRequestBelogstoCurrentUser(request)) {
        return false
    }
    if (!request.status) return false
    if (requestFilter.text === 'reset') {
        return true
    } else if (requestFilter.type === "status") {
        return request.status === requestFilter.text;
    } else if (requestFilter.type === "due_status") {
        // Handle "None" filter - show accepted requests
        if (requestFilter.text === 'None') {
            return request.status === constant.ACCEPTED;
        }
        // Due status chart excludes Accepted requests (same as chart logic)
        if (request.status === constant.ACCEPTED)
            return false
        let today = moment().format(constant.DATE_FORMAT)
        let week_one_date = moment().add(7, 'days').format(constant.DATE_FORMAT)
        let week_two_date = moment().add(14, 'days').format(constant.DATE_FORMAT)
        let dueDate = '';
        // Calculate due date as created_date + deadline (when request was created)
        if (request.created_date && request.default_date_offset !== undefined && request.default_date_offset !== null) {
            dueDate = moment(request.created_date).add(request.default_date_offset, 'days').format(constant.DATE_FORMAT)
        }
        if (requestFilter.text === 'Overdue') {
           
            if (dueDate < today) {
                return true; 
            }
           
            if (dueDate >= week_one_date) {
                return true; 
            }
            return false; 
        } else if (requestFilter.text === 'One week away from Overdue') {         
            if (dueDate >= today && dueDate < week_one_date) {
                return true;
            }
            return false;
        }
        else if (requestFilter.text === 'Due in two weeks') {
            if (dueDate < today || dueDate < week_one_date)
                return false
            return dueDate < week_two_date;
        } else return false
    } else if (requestFilter.type === "perPerson") {      
        if (requestFilter.text.startsWith('Unassigned')) {
            let hasAssignee = false
            request.clients.forEach((usr) => {
                if (usr.email && usr.email !== "" && usr.email !== null) {                   
                    if (getSlicedCurrentUser().email !== usr.email && (getCurrentUserRole() === 'ClientAdmin')) {
                        hasAssignee = true
                    } else if ((getSlicedCurrentUser().email === usr.email) && !usr.role.includes(constant.ADMIN)) {
                        hasAssignee = true
                    }
                }
            })
            // Return true if no assignee matches the criteria
            return !hasAssignee
        }
        
        // Handle specific user email - must match assignment criteria (same logic as chart)
        let isFount = false
        request.clients.forEach((usr) => {
            // Check if the filter email matches the client email AND matches assignment criteria
            if (usr.email && usr.email !== "" && usr.email !== null && usr.email === requestFilter.text) {
                // Use same logic as chart: ClientAdmin sees other users, ClientUser sees themselves
                if (getCurrentUserRole() === 'ClientAdmin' && getSlicedCurrentUser().email !== usr.email) {
                    isFount = true
                } else if (getSlicedCurrentUser().email === usr.email && !usr.role.includes(constant.ADMIN)) {
                    isFount = true
                }
            }
        })
        return !!(isFount);
    }
})
export const manageStatusColor = ((status) => {
    switch (status) {
        case ('inProgress'): return <Typography sx={{ fontSize: 'inherit' }}>{constant.IN_PROGRESS}</Typography>
        case ('overDue'): return <Typography sx={{ fontSize: 'inherit' }}>! Over due</Typography>
        case ('Accepted'): return <Typography sx={{ color: constant.ACCEPT_COLOR, fontSize: 'inherit' }}>{constant.ACCEPTED}</Typography>
        case ('Rejected'): return <Typography sx={{ color: constant.REJECT_COLOR, fontSize: 'inherit' }}>{constant.REJECTED}</Typography>
        case ('Submitted'): return <Typography sx={{ color: constant.SUBMIT_COLOR, fontSize: 'inherit' }}>{constant.SUBMITTED}</Typography>
        default: return <Typography sx={{ fontSize: 'inherit' }}>{constant.REQUESTED}</Typography>
    }
})
export const manageStatusColor2 = ((rq, Collection) => {
    if (!rq?.status) return <Typography sx={{ fontSize: 'inherit' }}> -- --</Typography>
    let today = moment().format(constant.DATE_FORMAT)
    let dueDate = ''
    // Calculate due date as created_date + deadline (when request was created)
    if (rq?.created_date && rq?.default_date_offset !== undefined && rq?.default_date_offset !== null) {
        dueDate = moment(rq.created_date).add(rq.default_date_offset, 'days').format(constant.DATE_FORMAT)
    }
    if (dueDate < today && (rq?.status === constant.ACCEPTED ? false : rq?.status === constant.REJECTED ? false : rq?.status === constant.SUBMITTED ? false : true)) {
        return <Typography sx={{ color: constant.REJECT_COLOR, fontSize: 'inherit' }}>OverDue</Typography>
    } else {
        switch (rq?.status) {
            case ('inProgress'): return <Typography sx={{ fontSize: 'inherit' }}>{constant.IN_PROGRESS}</Typography>
            case ('Accepted'): return <Typography sx={{ color: constant.ACCEPT_COLOR, fontSize: 'inherit' }}>{constant.ACCEPTED}</Typography>
            case ('Rejected'): return <Typography sx={{ color: constant.REJECT_COLOR, fontSize: 'inherit' }}>{constant.REJECTED}</Typography>
            case ('Submitted'):
                if (rq?.not_applicable) {
                    return <Typography sx={{ color: constant.SUBMIT_COLOR, fontSize: 'inherit' }}>Submitted/NA</Typography>
                } else
                    return <Typography sx={{ color: constant.SUBMIT_COLOR, fontSize: 'inherit' }}>{constant.SUBMITTED}</Typography>
            case ('Requested'): return <Typography sx={{ color: '#8A989B', fontSize: 'inherit' }}>{constant.REQUESTED}</Typography>
            default: return '-- -- '
        }
    }
})
export const isDue = ((rq, Collection) => {
    let today = moment().format(constant.DATE_FORMAT)
    let dueDate = ''
    // Calculate due date as created_date + deadline (when request was created)
    if (rq.created_date && rq.default_date_offset !== undefined && rq.default_date_offset !== null) {
        dueDate = moment(rq.created_date).add(rq.default_date_offset, 'days').format(constant.DATE_FORMAT)
    }
    if (dueDate < today) {
        return true
    }
})
export const manageDueStatus = ((rq, Collection) => {
    let today = moment().format(constant.DATE_FORMAT)
    let dueDate = ''
    // Calculate due date as created_date + deadline (when request was created)
    if (rq?.created_date && rq?.default_date_offset !== undefined && rq?.default_date_offset !== null) {
        dueDate = moment(rq.created_date).add(rq.default_date_offset, 'days').format(constant.DATE_FORMAT)
    }
    if (dueDate < today && (rq?.status === constant.ACCEPTED ? false : rq?.status === constant.REJECTED ? false : rq?.status === constant.SUBMITTED ? false : true)) {
        return true
    }
})
export const manageStatusTextColor = ((rq) => {
    switch (rq.status) {
        case ('inProgress'): return 'black';
        case ('Accepted'): return "#009F46";
        case ('Rejected'): return constant.REJECT_COLOR;
        case ('Submitted'): return '#fa983e';
        default:
            return '#b9c5c7';
    }
})
export const valuateFormRegex = ((evt, regex) => {
    if (['Backspace'].includes(evt.key))
        return true
    if ([' ', 'Space'].includes(evt.key))
        return true
    if (['.'].includes(evt.key)) {
        evt.preventDefault()
    }
    if (regex) {
        let regx = new RegExp(regex)
        if (regx) {
            if (regx.test(evt.key) === false) evt.preventDefault()
        } else return true
    }
})
export const alphaNumericOnly = ((evt, regex) => {
    if (['Backspace'].includes(evt.key))
        return true
    if (regex) {
        let regx = new RegExp(regex)
        if (regx) {
            if (regx.test(evt.key) === false) evt.preventDefault()
        } else return true
    }
})
export const replaceWith = ((val, arr, to) => {
    arr.forEach((a) => {
        val = val.split(a).join(to)
    })
    return val
})
export const validateUrl = ((val) => {
    let arr = ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '{', '}', '[', ']', ':', '~', '"', "'", '//', '>', '<', '.', ' ', '`']
    arr.forEach((a) => {
        val = val.split(a).join('')
    })
    return val
})
// Validate Google Drive path - allows spaces but removes truly invalid characters
export const validateGoogleDrivePath = ((val) => {
    if (!val) return val
    // Remove invalid characters for file/folder names: < > : " | ? * and control characters
    // Also normalize multiple slashes to single slash
    return val.replace(/[<>:"|?*\x00-\x1f]/g, '').replace(/\/\/+/g, '/')
})
export const removeExtraDatasFromTreeView = ((detail) => {
    let g = detail['requests']['structure']['sections']
    let temp = []
    g.forEach((section) => {
        delete section['expanded']
        delete section['subChild']
        section = { ...section, subChild: [] }
        section = { ...section, id: '' }
        section = { ...section, expanded: '' }
        section.sub_section.map((subsec) => {
            subsec = { ...subsec, subChild: [] }
            subsec = { ...subsec, id: '' }
            subsec = { ...subsec, expanded: '' }
            return subsec
        })
        temp.push(section)
    })
    return temp
})

export const getCollectionStatus = (collection) => {
    let collection_status = collection.status;
    let res = { requested_percentage: 0, accepted_percentage: 0, rejected_percentage: 0, submitted_percentage: 0 };
    let total_req = collection_status?.total_req, accepted = collection_status?.accepted, rejected = collection_status?.rejected, submitted = collection_status?.submitted, requested = collection_status?.requested;
    let requested_pct = (requested / total_req) * constant.WIDTH;
    res.requested_percentage = isNaN(requested_pct) ? "0" : requested_pct.toFixed(0);
    let submitted_pct = (submitted / total_req) * constant.WIDTH;
    res.submitted_percentage = isNaN(submitted_pct) ? "0" : submitted_pct.toFixed(0);
    let rejected_pct = (rejected / total_req) * constant.WIDTH;
    res.rejected_percentage = isNaN(rejected_pct) ? "0" : rejected_pct.toFixed(0);
    let accepted_pct = (accepted / total_req) * constant.WIDTH;
    res.accepted_percentage = isNaN(accepted_pct) ? "0" : accepted_pct.toFixed(0);
    return [
        { percentage: Number(res.accepted_percentage), total: total_req, req: accepted, color: constant.ACCEPT_COLOR, task: constant.ACCEPTED },
        { percentage: Number(res.submitted_percentage), total: total_req, req: submitted, color: constant.SUBMIT_COLOR, task: constant.SUBMITTED },
        { percentage: Number(res.rejected_percentage), total: total_req, req: rejected, color: constant.REJECT_COLOR, task: constant.REJECTED },
        { percentage: Number(res.requested_percentage), total: total_req, req: requested, color: "#ADADAD", task: constant.REQUESTED },
    ]
};

export const CollectionStatusText = ((collection, type) => {
    let status = '';
    let collection_status = collection.status;
    let total_req = collection_status?.total_req, accepted = collection_status?.accepted, rejected = collection_status?.rejected, submitted = collection_status?.submitted, requested = collection_status?.requested;
    let in_progress = requested + submitted + rejected;
    if (accepted === total_req && total_req > 0) {
        if (type === "export") {
            status = "Completed"

        } else {
            status = <Typography sx={{ color: constant.ACCEPT_COLOR, fontSize: 'inherit' }}> Completed </Typography>
        }
    } else if (in_progress > 0) {
        if (type === "export") {
            status = constant.IN_PROGRESS

        } else {
            status = <Typography sx={{ color: constant.SUBMIT_COLOR, fontSize: 'inherit' }}> {constant.IN_PROGRESS} </Typography>
        }
    } else {
        status = ' -- -- '
    }
    return status
})

export const CollectionStatusColor = ((collection) => {
    let color = '';
    let collection_status = collection.status;
    let total_req = collection_status?.total_req, accepted = collection_status?.accepted, rejected = collection_status?.rejected, submitted = collection_status?.submitted, requested = collection_status?.requested;
    let in_progress = requested + submitted + rejected;
    if (accepted === total_req && total_req > 0) {
        color = "#009F46"
    } else if (in_progress > 0) {
        color = "#F1AF05"
    }
    return color
})

export const haveDriveUpload = ((collection) => {
    if (collection['external_storage'])
        return collection['external_storage']['need_google_drive'] === "true"
    else
        return false
})

export const haveDcDataRoomUpload = ((collection) => {
    if (collection['external_storage'])
        return collection['external_storage']['need_dc_dataroom'] === "true"
    else
        return false
})

export const haveDataRoomUpload = ((collection) => {
    return collection['issuer_id'] ? true : false
})

export const manageMarkasReadyButton = ((collection, getcount) => {
    let pending_marked_as_ready_items = 0
    let need_more_data_in_requests = 0
    let total_req = 0;
    if (collection.requests)
        collection.requests.structure.sections.forEach((sec) => {
            if (sec.requests) {
                total_req = total_req + sec.requests.length
                let is_marked_as_ready = sec.requests.filter((req) => req.is_marked_as_ready === 0)

                if (collection?.issuer_id) {//check for dataroom required fields
                    // let need_more_data = sec.requests.filter((req) => (req.dr_file_location === null && (req.attachments[0].type === constant.FILE || req.attachments[0].type === constant.LINK)))
                    let need_more_data = sec.requests.filter((req) => ((req.dr_file_location === null || req.dr_file_location === "") && (req.attachments[0].type === constant.FILE || req.attachments[0].type === constant.LINK)))

                    need_more_data_in_requests = need_more_data_in_requests + need_more_data.length
                }
                if (collection.external_storage) {//check for google drive required fields
                    if (haveDriveUpload(collection)) {
                        let need_more_data = sec.requests.filter((req) => (!req.drive_file_location && (req.attachments[0].type === constant.FILE || req.attachments[0].type === constant.LINK)))
                        need_more_data_in_requests = need_more_data_in_requests + need_more_data.length
                    }
                }
                pending_marked_as_ready_items = pending_marked_as_ready_items + is_marked_as_ready.length
            }
            sec.sub_section.forEach((sub_sec) => {
                total_req = total_req + sub_sec.requests.length
                let is_marked_as_ready = sub_sec.requests.filter((req) => req.is_marked_as_ready === 0)
                if (collection?.issuer_id) {
                    let need_more_data = sub_sec.requests.filter((req) => ((req.dr_file_location === null || req.dr_file_location === "") && (req.attachments[0].type === constant.FILE || req.attachments[0].type === constant.LINK)))
                    need_more_data_in_requests = need_more_data_in_requests + need_more_data.length
                }
                if (collection.external_storage) {
                    if (haveDriveUpload(collection)) {
                        let need_more_data = sub_sec.requests.filter((req) => (!req.drive_file_location && (req.attachments[0].type === constant.FILE || req.attachments[0].type === constant.LINK)))
                        need_more_data_in_requests = need_more_data_in_requests + need_more_data.length
                    }
                }
                pending_marked_as_ready_items = pending_marked_as_ready_items + is_marked_as_ready.length
            })
        })
    if (getcount === "getcount")
        return need_more_data_in_requests;
    return pending_marked_as_ready_items === 0 || need_more_data_in_requests > 0;

})
export const canCreateTemplate = ((collection) => {
    return atleastOneRequestinCollection(collection)
})
const populateClientsFromCollectionLeval = ((clients_r, clients_c) => {
    let roles = [], arr = [];
    clients_r.forEach((usr) => {
        usr.role.forEach((item) => {
            if (!roles.includes(item)) roles.push(item)
        })
    })
    roles.forEach((role) => {
        clients_c.forEach((usr) => {
            if (usr.role.includes(role)) arr.push(usr)
        })
    })
    return arr
})

export const makeAllMarkasReady = ((collection, clients) => {
    let total_req = 0;
    if (collection.requests)
        collection.requests.structure.sections.map((sec) => {
            if (sec.requests) {
                sec.requests.map((req) => {
                    req.is_marked_as_ready = 1
                    if (!req.copied_to_dataroom) {
                        req.copied_to_dataroom = 0
                    }
                    if (!req.status) {
                        req.status = constant.REQUESTED
                    }
                    req.clients = populateClientsFromCollectionLeval(req.clients, clients)
                    return req
                })
            }
            sec.sub_section.map((sub_sec) => {
                total_req = total_req + sub_sec.requests.length
                sub_sec.requests.map((_req) => {
                    _req.is_marked_as_ready = 1
                    if (!_req.copied_to_dataroom) {
                        _req.copied_to_dataroom = 0
                    }
                    if (!_req.status) {
                        _req.status = constant.REQUESTED
                    }
                    _req.clients = populateClientsFromCollectionLeval(_req.clients, clients)
                    return _req
                })
                return sub_sec
            })
            return sec
        })
    return collection
})
export const addTempId = ((collection) => {
    let i = 0
    if (collection.requests)
        collection.requests.structure.sections.map((sec) => {
            if (sec.requests) {
                sec.requests.map((req) => {
                    req.temp_id = i++
                    return req
                })
            }
            sec.sub_section.map((sub_sec) => {
                sub_sec.requests.map((_req) => {
                    _req.temp_id = i++
                    return _req
                })
                sub_sec.temp_id = i++
                return sub_sec
            })
            sec.temp_id = i++
            return sec
        })
    return collection
})
export const resetToDefaultRequestObj = ((sections, collection) => {
    let agentObj = []
    let usr = getSlicedCurrentUser()
    usr['review_status'] = 0 //1,2,3
    agentObj.push(usr)
    let res = []
    sections.forEach((sec) => {
        sec.requests.map((request) => {
            request.req_id = collection.id + '_' + uuidv4().slice(24)
            request.status = ''
            request['is_marked_as_ready'] = 0
            request['agents'] = agentObj
            request.copied_to_dataroom = 0
            request.clients = [{ "role": [constant.ADMIN], "email": "", "access": "admin" }]
            request['accept_by'] = 'any'
            if ((request.attachments[0].type === constant.LINK || request.attachments[0].type === constant.FILE)) {
                request.dr_default_filename = request.dr_default_filename ?? null
                request.dr_file_location = request.dr_file_location ?? null
                request.dr_file_type = request.dr_file_type ?? 'issuer'
                request.dr_watermark = request.dr_watermark ?? false
                request.dr_read_only = request.dr_read_only ?? false
                // Preserve template drive_file_location, or use collection name as default
                if (!request.drive_file_location) {
                    const collectionName = collection?.collection_title || collection?.client_name || usr?.user_name;
                    // Preserve spaces in folder names, only remove truly invalid characters
                    request.drive_file_location = (collectionName || '').replace(/[<>:"|?*\x00-\x1f]/g, '') + '/'
                }
                // request.drive_default_filename = request.drive_default_filename ?? null
            }
            return request
        })
        sec.sub_section.map((sub_sec) => {
            sub_sec.requests.map((_request) => {
                _request.req_id = collection.id + '_' + uuidv4().slice(24)
                _request['is_marked_as_ready'] = 0
                _request['agents'] = agentObj
                _request.copied_to_dataroom = 0
                _request.clients = [{ "role": [constant.ADMIN], "email": "", "access": "" }]
                _request['accept_by'] = 'any'
                if ((_request.attachments[0].type === constant.LINK || _request.attachments[0].type === constant.FILE)) {
                    _request.dr_default_filename = _request.dr_default_filename ?? null
                    _request.dr_file_location = _request.dr_file_location ?? null
                    _request.dr_file_type = _request.dr_file_type ?? 'issuer'
                    _request.dr_watermark = _request.dr_watermark ?? false
                    _request.dr_read_only = _request.dr_read_only ?? false
                    // Preserve template drive_file_location, or use collection name as default
                    if (!_request.drive_file_location) {
                        const collectionName = collection?.collection_title || collection?.client_name || usr?.user_name;
                        // Preserve spaces in folder names, only remove truly invalid characters
                        _request.drive_file_location = (collectionName || '').replace(/[<>:"|?*\x00-\x1f]/g, '') + '/'
                    }
                    // _request.drive_default_filename = _request.drive_default_filename ?? null
                }
                return _request
            })
        })
        res.push(sec)
    })
    return res
})

const slicedName = ((name) => {
    let nm = name.split('.')[0]
    let ext = name.split('.')[1]
    nm = nm.substring(0, 200);
    if (ext)
        return nm + '.' + ext
    return nm
})

export const downloadURI = async (Attachments) => {
    Attachments.map(async (fl) => {
        getS3SignedUrl(fl.url).then(res => {
            fetch(res.data?.presigned_url)
                .then(_res => _res.blob())
                .then(blob => {
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    if (fl.name.length > 254)
                        fl.name = slicedName(fl.name)
                    link.download = fl.name;
                    link.click();
                })
                .catch((e) => {
                    console.log(e)
                    alert(fl.url + "- Unable to download!")
                })
        })

    })
}

export const LeftSideBubbles = (props) => {
    let { request, Collection } = props;
    let color = manageStatusTextColor(request);
    let today = moment().format(constant.DATE_FORMAT)
    let dueDate = ''
    if (request.offset_from === "start") {
        let startDate;
        if (Collection.start_date instanceof Date) {
            startDate = moment(Collection.start_date.toISOString())
        } else if (typeof Collection.start_date === 'string') {
            startDate = moment(Collection.start_date, constant.DATE_FORMAT, true)
            if (!startDate.isValid()) {
                startDate = moment(Collection.start_date)
            }
        } else {
            startDate = moment(Collection.start_date)
        }
        dueDate = startDate.add(request.default_date_offset, 'days').format(constant.DATE_FORMAT)
    } else {
        let dueDateSource;
        if (Collection.due_date instanceof Date) {
            dueDateSource = moment(Collection.due_date.toISOString())
        } else if (typeof Collection.due_date === 'string') {
            dueDateSource = moment(Collection.due_date, constant.DATE_FORMAT, true)
            if (!dueDateSource.isValid()) {
                dueDateSource = moment(Collection.due_date)
            }
        } else {
            dueDateSource = moment(Collection.due_date)
        }
        dueDate = dueDateSource.subtract(request.default_date_offset, 'days').format(constant.DATE_FORMAT)
    }
    if (dueDate < today && (request.status === constant.ACCEPTED ? false : request.status === constant.REJECTED ? false : request.status === constant.SUBMITTED ? false : true))
        return <ErrorRoundedIcon sx={{ color: constant.REJECT_COLOR, fontSize: "22px" }} />;
    if (request.status === constant.ACCEPTED)
        return <CheckCircleIcon sx={{ color: color, fontSize: "22px" }} />;
    else {
        if (request.status === constant.REQUESTED && color !== constant.REJECT_COLOR)
            return <Brightness1Icon sx={{ color: color, fontSize: "22px" }} />;
        else if (request.status === constant.SUBMITTED)
            return <Brightness1Icon sx={{ color: color, fontSize: "22px" }} />;
        else
            return <ErrorRoundedIcon sx={{ color: color, fontSize: "22px" }} />;
    }
};
const validateUserData = (parsedObj) => {
    try {
        if (!(
            parsedObj.hasOwnProperty('access_token') &&
            parsedObj.hasOwnProperty('current_role') &&
            parsedObj.hasOwnProperty('email') &&
            parsedObj.hasOwnProperty('selected_tenant') &&
            parsedObj.hasOwnProperty('tenant') &&
            parsedObj.hasOwnProperty('tenant_details') &&
            parsedObj.hasOwnProperty('user_tenant_details') &&
            parsedObj.hasOwnProperty('id')
        )) {
            console.log('required datas not found')
            localStorage.removeItem('user')
            window.location.reload()
        }
    }
    catch (e) {
        console.log(e, 'required datas not found')
        localStorage.removeItem('user')
        window.location.reload()
    }
}
export const getUserData = () => {
    let user = localStorage.getItem('user')
    if (user !== null) {
        try {
            let decoded = window.atob(user);
            let parsedObj = JSON.parse(decoded)
            if (parsedObj) {
                validateUserData(parsedObj)
            }
            return parsedObj
        }
        catch (e) {
            return null
        }
    } else return null
}
export const myTenant = () => {
    let user = getUserData()
    if (user !== null) {
        return user.tenant
    } else return null
}
export const putUserData = (data) => {
    let encoded = window.btoa(JSON.stringify(data));
    localStorage.setItem('user', encoded)
}

export const checkAgentAdmin = () => {
    let user = localStorage.getItem("user");
    if (user !== null) {
        try {
            let decoded = window.atob(user);
            let parsed = JSON.parse(decoded);
            if (parsed.current_role === 4) {
                return "AdminUser";
            }
        }
        catch (e) {
            return null
        }
    } else return null;
}
export const getCurrentUserRole = () => {
    let user = localStorage.getItem("user");
    if (user !== null) {
        try {
            let decoded = window.atob(user);
            let parsed = JSON.parse(decoded);
            if (parsed.current_role === 1) return "SuperAdmin";
            if (parsed.current_role === 2) return "AgentAdmin";
            else if (parsed.current_role === 4) return "AgentUser";
            else if (parsed.current_role === 3) return "ClientAdmin";
            else if (parsed.current_role === 5) return "ClientUser";
            else if (parsed.current_role === 6) return constant.DC_SUPER_ADMIN;
            return null;
        }
        catch (e) {
            return null
        }
    } else return null;
};
export const updateToLocalIfSameTenant = ((res) => {
    let localData = getUserData()
    if (localData.selected_tenant === res.id) {
        res.tenant_details['tenant_name'] = res.tenant_name
        let tenantInfo = res.tenant_configuration;
        tenantInfo.tenant_name = res.tenant_name;
        tenantInfo.logo = res.tenant_details.logo;
        tenantInfo.email = res.tenant_details.email;
        tenantInfo.theme_color = res.tenant_details.theme_color;
        localData['tenant'] = tenantInfo;
        putUserData(localData)
        // window.location.reload()
    }
})
export const userRolesAsNames = (user_roles) => {
    let roles = []
    let arr = [constant.SUPER_ADMIN, constant.AGENT_ADMIN, constant.CLIENT_ADMIN, constant.AGENT_USER, constant.CLIENT_USER, constant.DC_SUPER_ADMIN]
    if (user_roles) {
        user_roles.map((rl) => {
            roles.push(arr[rl - 1])
        })
    } else {
        roles.push(constant.CLIENT_USER)
    }
    return roles
}
export const tenantUserRoles = (user_roles, tenantID) => {
    let arr = [];
    user_roles.filter((r) => r.tenant_id === tenantID).map((roles) => {
        roles.user_roles.map((role) => {
            arr.push(userRoleName(Number(role.role_id)))
        })
    })
    return arr
}
export const userTenants = (user_tenant) => {
    let arr = [];
    const tenantIndex = user_tenant.findIndex(tdetail => tdetail.tenant_id == getUserData()?.selected_tenant);
    user_tenant.push(...user_tenant.splice(0, tenantIndex));
    user_tenant.map((tenant) => {
        arr.push(tenant.tenant_name)
    })
    return arr

}
export const userNameAsRole = (user_role) => {
    let arr = [constant.SUPER_ADMIN, constant.AGENT_ADMIN, constant.CLIENT_ADMIN, constant.AGENT_USER, constant.CLIENT_USER, constant.DC_SUPER_ADMIN]
    if (user_role)
        return arr.indexOf(user_role) + 1
}
export const userRoleName = (user) => {
    if (user === 1) {
        return constant.SUPER_ADMIN
    }
    if (user === 2) {
        return constant.AGENT_ADMIN
    }
    if (user === 3) {
        return constant.CLIENT_ADMIN
    }
    if (user === 4) {
        return constant.AGENT_USER
    }
    if (user === 5) {
        return constant.CLIENT_USER
    }
    if (user === 6) {
        return "DC-Super Admin"
    }
}
export const getUserRolesObj = (val) => {
    let roles = []
    if (val.includes(1)) {
        roles.push({ label: constant.SUPER_ADMIN, value: 1, label_db: "super_admin" });
    }
    if (val.includes(2)) {
        roles.push({ label: constant.AGENT_ADMIN, value: 2, label_db: "agent_admin" });
    }
    if (val.includes(3)) {
        roles.push({ label: constant.CLIENT_ADMIN, value: 3, label_db: "client_admin" });
    }
    if (val.includes(4)) {
        roles.push({ label: constant.AGENT_USER, value: 4, label_db: "agent_user" });
    }
    if (val.includes(5)) {
        roles.push({ label: constant.CLIENT_USER, value: 5, label_db: "client_user" });
    }
    if (val.includes(6)) {
        roles.push({ label: constant.DC_SUPER_ADMIN, value: 6, label_db: "dc_super_admin" });
    }
    return roles;
};

export const getSlicedCurrentUser = () => {
    let user = localStorage.getItem('user')
    if (user !== null) {
        try {
            let decoded = window.atob(user);
            let val = JSON.parse(decoded)
            return {
                email: val.email,
                user_access_level: val.user_access_level,
                user_name: val.user_name,
                user_role_id: val.user_role_id,
                user_id: val.id,
            }
        }
        catch (e) {
            return null
        }
    } else {
        window.location.pathname = '/signin'
        return null
    }
}
export const isRequestBelogstoCurrentUser = ((request) => {
    if (getCurrentUserRole() === 'ClientAdmin') {
        /** match user email and atleast one email with role as 'Admin' */
        return request.clients.find((cl) => (cl.email === getSlicedCurrentUser().email) && cl.role.includes(constant.ADMIN));
    }
    if (getCurrentUserRole() === 'ClientUser') {
        /** match user email and email role not be an 'Admin' */
        return request.clients.find((cl) => (cl.email === getSlicedCurrentUser().email) && !cl.role.includes(constant.ADMIN));
    }
})
export const atleastOneRequestBelogstoCurrentUserinAllCollections = ((collections) => {
    return collections.filter((collection) => {
        let sections = collection.requests.structure.sections.filter((sec) => {
            let seclevel = []
            let sub_seclevel = []
            if (getCurrentUserRole() === 'ClientUser') {
                seclevel = sec.requests.filter((request) => request.clients.find((cl) => (cl.email === getSlicedCurrentUser().email) && !cl.role.includes(constant.ADMIN)))
                sub_seclevel = sec.sub_section.filter((sub) => sub.requests.filter((request) => request.clients.find((cl) => (cl.email === getSlicedCurrentUser().email) && !cl.role.includes(constant.ADMIN))))
            }
            if (getCurrentUserRole() === 'ClientAdmin') {
                seclevel = sec.requests.filter((request) => request.clients.find((cl) => (cl.email === getSlicedCurrentUser().email) && cl.role.includes(constant.ADMIN)))
                sub_seclevel = sec.sub_section.filter((sub) => sub.requests.filter((request) => request.clients.find((cl) => (cl.email === getSlicedCurrentUser().email) && cl.role.includes(constant.ADMIN))))
            }
            return seclevel.length || sub_seclevel.length
        })
        return sections.length > 0
    })
})
export const atleastOneRequestinCollection = ((collection) => {
    let total_req = 0;
    if (collection?.requests)
        collection.requests.structure.sections.forEach((sec) => {
            if (sec.requests) {
                total_req = total_req + sec.requests.length
            }
            sec.sub_section.forEach((sub_sec) => {
                total_req = total_req + sub_sec.requests.length
            })
        })
    return total_req > 0;
})

export const getClientList = ((collection) => {
    let sec_clients = [];
    let subsec_clients = [];
    if (collection.requests)
        collection.requests.structure.sections.forEach((sec) => {
            if (sec.requests) {
                sec.requests.forEach((req) => {
                    req.clients.forEach((client) => {
                        sec_clients.push(client.role[0])
                    })
                })
            }
            sec.sub_section.forEach((sub_sec) => {
                if (sub_sec.requests) {
                    sub_sec.requests.forEach((req) => {
                        req.clients.forEach((client) => {
                            subsec_clients.push(client.role[0])
                        })
                    })
                }
            })
        })
    const concat = sec_clients.concat(subsec_clients);
    let set = new Set(concat)
    return [...set]
})

export const requestType = ((type, context) => {
    // console.log(type)
    switch (type) {
        case ('file'): return <Tooltip title="File" placement="top">
            <FileIcon style={{ width: context === 'submission' ? '24px' : '', height: context === 'submission' ? '24px' : '', marginTop: context === 'import' ? '1px' : '' }} />
        </Tooltip>
        case ('plainText'): return <Tooltip title="Text" placement="top">
            <TextIcon style={{ width: context === 'submission' ? '24px' : '', height: context === 'submission' ? '24px' : '', marginTop: context === 'import' ? '3px' : '1px' }} />
        </Tooltip>
        case ('form'): return <Tooltip title="Form" placement="top">
            <FormIcon style={{ width: context === 'submission' ? '24px' : '', height: context === 'submission' ? '24px' : '', marginTop: context === 'import' ? '1px' : '' }} />
        </Tooltip>
        case ('link'): return <Tooltip title="Link" placement="top">
            <LinkIcon style={{ width: context === 'submission' ? '24px' : '', height: context === 'submission' ? '24px' : '', marginTop: context === 'import' ? '3px' : '1px' }} />
        </Tooltip>
        default: return <Typography sx={{ fontSize: 'inherit' }}>{type}</Typography>
    }
})

export const atleastOneRequestBelogstoCurrentUser = ((requests) => {
    let status = false
    requests.forEach((request) => {
        if (request.clients.find((cl) => cl.email === getSlicedCurrentUser().email))
            status = true
    })
    return status
})
export const isRequestBelogstoCurrentAgentAdmin = ((request) => {
    let status = false
    if (request.agents.find((ag) => ag.email === getSlicedCurrentUser().email))
        status = true
    return status
})
export const isRequestBelogstoCurrentAgentAdminWithStatus = ((request) => {
    let status = false
    if (request.agents.find((ag) => (ag.email === getSlicedCurrentUser().email && ag.review_status === 0)))
        status = true
    return status
})
export const validateEmail = ((email) => {
    if (typeof email !== "undefined") {
        let lastAtPos = email.lastIndexOf("@");
        let lastDotPos = email.lastIndexOf(".");
        return !(!(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            email.indexOf("@@") === -1 &&
            lastDotPos > 2 &&
            email.length - lastDotPos > 2
        ));
    }
    return false
})
export const focusDroppedItem = ((temp_id) => {
    setTimeout(() => {
        if (!document.getElementById(temp_id + '-temp_id')) return
        document.getElementById(temp_id + '-temp_id').style.background = "#3ba4801a"
        document.getElementById(temp_id + '-temp_id').scrollIntoView({
            block: 'center',
            inline: 'center'
        });
    }, 50)
    setTimeout(() => {
        document.getElementById(temp_id + '-temp_id').style.background = "inherit"
    }, 10000)
})
export function piePercentage(accepted, total) {
    if (total === 0) return 0
    return ((accepted * 100) / total).toFixed(1)
}
export const getS3FolderStructure = ((collection_id, SecIndex, SubSecIndex, Request_title) => {
    SecIndex = "sec_" + parseInt(SecIndex)
    let path = ''
    path = collection_id + '/' + SecIndex + '/' + Request_title
    if (SubSecIndex >= 0 && SubSecIndex) {
        SubSecIndex = 'sub_sec_' + parseInt(SubSecIndex)
        path = collection_id + '/' + SecIndex + '/' + SubSecIndex + '/' + Request_title

    }
    return path.split(/\s/).join('_') + '/';
})
export const getLetters = num => {
    let mod = num % 26,
        pow = num / 26 | 0,
        out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');
    return pow ? getLetters(pow) + out : out;
}
export function dataURItoBlob(dataURI) {
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = decodeURI(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    let ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}

export const CustomToolTip = ((p) => {
    const BlueOnGreenTooltip = withStyles({
        arrow: {
            "&:before": {
                border: "1px solid #323A3C"
            },
            color: '#323A3C',

        },
        tooltip: {
            color: "white",
            backgroundColor: "#323A3C",
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
            minWidth: '200px',
        }
    })(Tooltip);
    let list = p.data.filter(v => v).map((v) => (
        <ol key={v} style={{ fontSize: '0.875rem', fontWeight: '400', margin: '', padding: '3px', textTransform: 'capitalize' }}>{v}
        </ol>
    ))
    let label = ''
    if (p.data.length === 0) {
        label = '-- --'
        list = ''
    } else if (p.data.length === 1) {
        label = p.data[0]
    } else
        label = "Multiple(" + (p.data.length === 0 ? 0 : p.data.length) + ')'
    return <BlueOnGreenTooltip title={list} arrow>
        <Box component="span" sx={{ fontWeight: '500', minWidth: '100px', maxWidth: "150px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", display: 'inline-block' }}>
            {label}
        </Box>
    </BlueOnGreenTooltip >
})
export const filterObjects = ((collections) => {
    return collections.filter((collection, collec_index) => {
        let all_req = []
        collection.requests.structure.sections.forEach((sec) => {
            if (sec.requests.length)
                all_req = [...all_req, ...sec.requests]
            sec.sub_section.forEach((sub_sec) => {
                if (sub_sec.requests.length)
                    all_req = [...all_req, ...sub_sec.requests]
            })
        })
        return all_req.find((request) => (isRequestBelogstoCurrentAgentAdmin(request)))
    })

})
export const arrangeReqWithIds = ((collection, admin) => {
    let arr_ids = []
    collection.requests?.structure?.sections.forEach((sec, sec_index) => {
        if (sec.requests) {
            sec.requests.forEach((req, req_index) => {
                if (admin === "agent_admin" || (isRequestBelogstoCurrentUser(req) && req.is_marked_as_ready)) {
                    arr_ids.push(req.req_id)
                }
            })
        }
        if (sec.sub_section) {
            sec.sub_section.forEach((sub_sec, sub_sec_index) => {
                sub_sec.requests.forEach((req, req_index) => {
                    if (admin === "agent_admin" || (isRequestBelogstoCurrentUser(req) && req.is_marked_as_ready)) {
                        arr_ids.push(req.req_id)
                    }
                })
            })
        }
    })
    return arr_ids
})

export const checkHaveComments = (file) => {
    let status = false
    if (file?.comment || file.comment === undefined) {
        status = true
    }
    return status
}

export const showCommentIcon = (file) => {
    let status = false
    if (file?.comment) {
        status = true
    }
    return status
}

export const managePriorityColor = ((priority) => {
    let color = "#FF982B";
    if (priority === "p1") {
        color = "#EF4640"
    }
    else if (priority === "p2") {
        color = "#FF982B"
    }
    else if (priority === "p3") {
        color = "#0063B1"
    }
    return color;
})

// export const managePriority = ((priority) => {
//     if (priority === undefined) {
//         // return <Typography sx={{ fontSize: "12px", color: "#000000" }}>-- --</Typography>
//         return <Typography sx={{ fontWeight: 500, fontSize: "12px", color: "#FFFFFF", padding: "4px 8px 4px 8px" }}>P2</Typography>
//     }
//     return <Typography sx={{ fontWeight: 500, fontSize: "12px", color: "#FFFFFF", padding: "4px 8px 4px 8px" }}>{priority.toUpperCase()}</Typography>
// })

export const managePriority = ((priority) => {
    if (priority === "p1") {
        return <Tooltip title="High" placement="top">
            <UpArrowIcon />
        </Tooltip>
    }
    else if (priority === "p3") {
        return <Tooltip title="Low" placement="top">
            <DownArrowIcon />
        </Tooltip>
    }
    else {
        return <Tooltip title="Medium" placement="top">
            <EqualToIcon />
        </Tooltip>
    }
})

export const allUserRoles = [
    { label: "Dc-Super Admin", role: 6, label_db: "dc_super_admin" },
    { label: "Super Admin", role: 1, label_db: "super_admin" },
    { label: "Agent Admin", role: 2, label_db: "agent_admin" },
    { label: "Agent User", role: 4, label_db: "agent_user" },
    { label: "Client Admin", role: 3, label_db: "client_admin" },
    { label: "Client User", role: 5, label_db: "client_user" }
]
export const splitColReqIds = ((collection_id) => {
    let c_id, r_id
    if (collection_id) {
        c_id = collection_id.split('_')[0]
        r_id = collection_id.split('_')[1]
    }
    return { c_id, r_id }
})
export const clearCPagination = (items) => {
    items.map((item) => {
        sessionStorage.removeItem(item)

    })
}
export const getThumbnailImg = ((url) => {
    if (url)
        return url.replace('/avatar', '/avatar/thumbnails')
    else return ''
})
export const getTermsPolicy = ((l, key) => {
    let url = ''
    if (l)
        url = l
    else
        url = process.env.REACT_APP_S3_BUCKET + 'Public/tenants/' + process.env.REACT_APP_DEFAULT_TENANT_NAME + '/' + key
    return url
})